import React from 'react';
import { WELCOME_MESSAGE } from '~/features/chatbot/constants/messages';
import { PREDEFINED_QUESTIONS } from '~/features/chatbot/constants/predefinedQuestions';

interface WelcomeMessageProps {
    onQuestionClick: (question: string) => void;
}

const WelcomeMessage: React.FC<WelcomeMessageProps> = ({ onQuestionClick }) => {
    return (
        <div className="welcome-message padding-20">
            <div className="welcome-message-bubble bg-lightest padding-15 rounded margin-bottom-15 max-width-75pct">
                <span className="rioglyph rioglyph-chat margin-right-5" aria-hidden="true"></span>
                <span>{WELCOME_MESSAGE}</span>
            </div>
            <div className="predefined-questions display-flex flex-wrap gap-10">
                {PREDEFINED_QUESTIONS.map((question) => (
                    <button
                        key={question}
                        type="button"
                        className="btn btn-default btn-sm"
                        onClick={() => onQuestionClick(question)}
                    >
                        {question}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default WelcomeMessage;
